/** L'app dei subvettori QBI Vettori si apre all'indirizzo /vettori (R3g, 122). */
export function eVettori(percorso: string): boolean {
  return /^\/vettori\/?$/i.test(percorso);
}
